// extracted by mini-css-extract-plugin
module.exports = {"container":"VM","links":"WM"};